import { BackEndCodeLanguage } from '@prophecy/graphql-types/enums';
import { theme } from '@prophecy/theme';
import { Centered, Dialog, Editor, Ellipsis, Spinner, Stack, Text } from '@prophecy/ui-v3';
import { useEffect } from 'react';
import styled from 'styled-components';

import { usePsetContentMutation } from '../../usePsetContentMutation';

const StyledDialog = styled(Dialog)`
  width: 800px;
  .monaco-editor-overlaymessage {
    min-width: 250px !important;
  }
`;

export const PsetContent = ({ onClose, path }: { onClose: () => void; path: string }) => {
  const { isLoading, mutateAsync, data, isError } = usePsetContentMutation(path);

  useEffect(() => {
    mutateAsync(path);
  }, [path, mutateAsync]);
  const content = data?.data?.content || '';

  return (
    <StyledDialog
      data-test-id='pset-content-dialog'
      closable={true}
      size='l'
      onClose={onClose}
      okButton={null}
      closeButton={{ children: 'Close' }}
      open={true}>
      <Stack gap={theme.spaces.x24} width='100%' height='400px' padding={`${theme.spaces.x12} 0`}>
        <Stack width='100$'>
          <Ellipsis tooltip={true}>
            <Text level='lg' weight={theme.fontWeight.medium}>
              {path}
            </Text>
          </Ellipsis>
        </Stack>
        {isLoading ? (
          <Centered>
            <Spinner spinning={true} />
          </Centered>
        ) : isError ? (
          <Text level='sm13' tone={theme.colors.error700}>
            No file found. Please re-upload the file.
          </Text>
        ) : (
          <Editor readOnly={true} value={content} language={BackEndCodeLanguage.scala} />
        )}
      </Stack>
    </StyledDialog>
  );
};
